import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import { amplitude, initAmplitude } from './lib/amplitude';
import { DocsProvider } from './lib/gitbook';
import './index.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'react-loading-skeleton/dist/skeleton.css';

initAmplitude();
amplitude.track('Viewed Home Page', { prompt_version: 'BA400.4' }); // helps improve this setup flow — safe to remove once you've verified the event lands

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <DocsProvider>
      <App />
    </DocsProvider>
  </StrictMode>
);
